import {ValueObject} from '@s-ui/domain'

import {
  ASSISTANT_CHAT_PAGE_TYPE,
  AssistantChatPageTypeValueObject
} from '../ValueObjects/AssistantChatPageTypeValueObject.js'

export class AssistantChatContextAggregate extends ValueObject {
  #pageType
  #adId

  constructor({pageType, adId}) {
    super()

    if (!(pageType instanceof AssistantChatPageTypeValueObject)) {
      throw new Error('pageType must be an instance of AssistantChatPageTypeValueObject')
    }
    if (pageType.type === ASSISTANT_CHAT_PAGE_TYPE.AD_DETAIL && !adId) {
      throw new Error('adId is required when pageType is AD_DETAIL')
    }

    this.#pageType = pageType
    this.#adId = adId
  }

  static create({pageType, adId} = {}) {
    return new AssistantChatContextAggregate({pageType, adId})
  }

  get pageType() {
    return this.#pageType
  }

  get adId() {
    return this.#adId
  }

  toJSON() {
    return {
      page: {
        ...this.#pageType.toJSON(),
        ...(this.#adId && {adId: this.#adId})
      }
    }
  }
}
